import { Domain } from 'app/core/domain';
import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class DomainTerminology implements ViewModel {
  friendlyTypeNameSingular = 'Domain Terminology';
  public readonly apiRoute: string = CONFIG.apiRoutes.domainTerminology;

  public domain: Domain;
  public terminologyData: any;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    if (!data) {
      return;
    }
    if (data.domainName) {
      this.domain = this.getDomainByName(data.domainName);
    }
    this.terminologyData = JSON.parse(data.terminologyData);
  }

  private getDomainByName(domainName: string): Domain {
    return Object.keys(Domain).includes(domainName) ? Domain[domainName] : Domain.Energy;
  }
}
